import { RouteConstants } from 'app/routes';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { matchPath, useLocation } from 'react-router-dom';
import { scrollToElementById } from 'utils/helpers';
import { useMapSlice } from '../../../slice';
import {
  selectActivePolygonId,
  selectMappedFieldsFilteredByCultureAndLayer,
} from '../../../slice/selectors';
import { IMappedField, MapModeEnum } from '../../../slice/types';
import { Field } from '../../fields/Field/Field';

interface IProps {
  mode: MapModeEnum;
  readOnly?: boolean;
}

const Fields = ({ mode, readOnly }: IProps) => {
  const dispatch = useDispatch();

  const { actions } = useMapSlice();

  const mappedFields = useSelector(selectMappedFieldsFilteredByCultureAndLayer);
  const activeFieldId = useSelector(selectActivePolygonId);
  const location = useLocation();

  useEffect(() => {
    if (mappedFields.length) {
      dispatch(actions.fitAllPolygonsOnMap());
    }
  }, [dispatch, actions, mappedFields.length]);

  const onFieldClick = (field: IMappedField) => {
    const {
      fieldParameters: { fieldId },
    } = field;

    scrollToElementById(`fieldItem${fieldId}`);

    if (readOnly) {
      return;
    }

    dispatch(
      actions.togglePolygon({
        fieldId,
      }),
    );
  };

  const toggleActivePolygon = (fieldId: number) => {
    if (matchPath(location.pathname, RouteConstants.field.list)) {
      dispatch(actions.toggleActivePolygonId(fieldId));
    }
  };

  const isActive = (fieldId: number) => {
    if (
      matchPath(location.pathname, RouteConstants.field.list) &&
      fieldId === activeFieldId
    ) {
      return true;
    }
    return false;
  };

  return (
    <>
      {mappedFields.map(mappedField => (
        <Field
          mode={mode}
          isActive={isActive(mappedField.fieldParameters.fieldId)}
          eventHandlers={{
            click() {
              onFieldClick(mappedField);
              toggleActivePolygon(mappedField.fieldParameters.fieldId);
            },
          }}
          mappedField={mappedField}
          key={mappedField.id}
          isSelected={mappedField.isSelected}
        />
      ))}
    </>
  );
};

export default Fields;
